// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2q1Kw","head":"ProcedureTableInfo_head__3zkI9"};